import "firebase/compat/firestore";
/**
 * Type-guard for distinguishing admin connections
 */
export function isAdminConnection(connection) {
    return typeof connection?.listCollections === "function";
}
/**
 * Type-guard for distinguishing client connections
 */
export function isClientConnection(connection) {
    return typeof connection?.enablePersistence === "function";
}
//# sourceMappingURL=connection.js.map